import { ClinicTaskListingModel, IClinicTaskListingModel, IOrderByParams } from "@common/models";
import { SearchService } from "@common/services/searchService";
import { StandardSearchStore } from "@common/stores";
import { isUndefined } from "lodash";
import { DateTime } from "luxon";
import { makeObservable } from "mobx";

export interface IClinicTaskUserFilterable {
	taskTypeId?: number;
	creatorUserId?: number;
	assignedUserId?: number;
	assignedRoleId?: number;
	dateCreated?: DateTime;
	dateDue?: DateTime;
	dateResolved?: DateTime;
	isUrgent?: boolean;
	startDate?: Date| string;
	endDate?: Date|string;
	resolvedByUserId?: number;
	resolvedBy?: string;
	petName?: string;
	

}
export interface IClinicTaskFilter extends IClinicTaskUserFilterable {
	hospitalId?: number;
	petId?: number;
	openTasks?: boolean;
	currentUserId?: number;
}

export const defaultClinicTaskSearchFilter: IClinicTaskFilter = {};

const defaultClinicTaskSortOrder = (openTasks?: boolean): IOrderByParams[] => {
	return (isUndefined(openTasks) || openTasks ? [{ field: "datecreated", dir: "desc" }] : [{ field: "closeddate", dir: "desc" }])};

interface ClinicTaskSearchStoreArgs {
	hospitalId: number;
	petId?:number;
	openTasks?: boolean;
	currentUserId?: number;
	top?: number;
	explicitLoad?: boolean;
	startDate?: string;
	endDate?: string;
	isPetTasks?: boolean;
	customOrderBy?: IOrderByParams[];
}
export class ClinicTaskSearchStore extends StandardSearchStore<IClinicTaskFilter, IClinicTaskListingModel, ClinicTaskListingModel> {
	constructor({ hospitalId, openTasks, currentUserId, top = 10, explicitLoad = true, endDate, startDate, petId, isPetTasks,  customOrderBy}: ClinicTaskSearchStoreArgs) {
		super(
			{				
				endpointUrl: explicitLoad ? (isPetTasks ? SearchService.SearchEndPoints.petTasks : SearchService.SearchEndPoints.tasks) : SearchService.SearchEndPoints.tasksCount,
				defaultSearchParams: {
					orderby:  defaultClinicTaskSortOrder(openTasks) ,
					top: top,
				},
				defaultSearchFilter: {
					...defaultClinicTaskSearchFilter,
					hospitalId,
					petId,
					openTasks,
					currentUserId,
					startDate,
					endDate,
				},
			},
			result => new ClinicTaskListingModel(result)
		);
		makeObservable(this, undefined);
	}
}
